module.exports = __webpack_public_path__ + "img/bg.9a2475cd.jpg";